import { gql } from '@apollo/client';

export const GET_PRIVACY_POLICY = gql`
  query getPrivacyPolicy {
    policy {
      data {
        attributes {
          privacyPolicy {
            content
            version
          }
        }
      }
    }
  }
`;
